<script setup lang='ts'>
const props = withDefaults(defineProps<{
  qrcode?: string
}>(), {})
</script>

<template>
  <div v-if="props.qrcode">
    <n-popover trigger="hover" display-directive="show" :show-arrow="false" raw>
      <template #trigger>
        <div class="hidden md:flex cursor-pointer items-center text-3.25 text-blue-5">
          <i class="i-carbon:send-alt-filled  text-3.75 mr-0.5" />
          小程序上浏览
        </div>
      </template>
      <div bg-white rounded p-2>
        <img w-30 h-30 :src="props.qrcode">
      </div>
    </n-popover>
  </div>
</template>

<style lang='scss' scoped>

</style>
